import { HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { isTrustedApiRequest } from '../utils/api-url.util';

/**
 * Blocks client-side requests to origins outside configured API hosts (SSRF mitigation).
 */
export const safeUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isTrustedApiRequest(req.url)) {
    return throwError(() => new Error('Blocked request to untrusted origin'));
  }

  return next(req);
};
